import styled from "styled-components";

import { ReactComponent as AnyswapSvg } from "assets/svgs/chainge-symbol.svg";
import { PulseLoader } from "react-spinners";
import { StyleProps } from "types/baseType";
import StyledContainer from "style/styledContainer";

type Props = {
  loading: boolean;
  text?: string;
} & StyleProps;

const LoadingWin = ({ loading, text = "Hold on, getting data", mt }: Props) => {

  return (
    <>
      {loading && (
        <LoadingBox>
          <AnyswapSvgWrapper stroke="#95a3be" $mt={mt || ''}></AnyswapSvgWrapper>
          <StyledContainer $p="5px 0" $fontSize="12px" $roobertRegular color="#95a3be">
            Hold on, getting data
          </StyledContainer>
          <PulseLoader
            color="#95a3be"
            cssOverride={{}}
            loading={true}
            margin={5}
            size={6}
            speedMultiplier={1}
          />
        </LoadingBox>
      )}
    </>
  );
};

const PopupWinBg = styled(StyledContainer)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: 'rgba(10, 10, 10, 0.8)';
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
`

const LoadingBox = styled(PopupWinBg)`
  border-radius: 12px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: rgba(255, 255, 255, 0.92);
  z-index: 90;
`;

const AnyswapSvgWrapper = styled(AnyswapSvg)<{$mt: string}>`
  width: 52px;
  height: 56px;

  margin-top: ${({ $mt }) => $mt || null};
`;

export default LoadingWin;
